import { Link } from "react-router-dom";
import { FileText, Phone } from "lucide-react";
import { CONTACT } from "../config";
import { fireConversion } from "../lib/tracking";
import { trackEvent } from "../lib/trackingClient";
import { WhatsAppIcon } from "./ContactActions";

const WA_TEXT = encodeURIComponent(
  "Hallo BA Media, ich interessiere mich für planbar neue Aufträge für meinen Betrieb."
);

// Mobil dauerhaft sichtbare Action-Bar: Formular · Anrufen · WhatsApp
export default function StickyActions() {
  const onCall = () => {
    fireConversion("anruf");
    trackEvent("anruf_click", { value: 50 });
    window.location.href = `tel:${CONTACT.phoneHref}`;
  };
  const onWhatsApp = () => {
    fireConversion("whatsapp");
    trackEvent("whatsapp_click", { value: 40 });
    window.open(`https://wa.me/${CONTACT.whatsapp}?text=${WA_TEXT}`, "_blank");
  };

  return (
    <div
      data-testid="sticky-bar"
      className="fixed bottom-0 left-0 right-0 z-40 grid grid-cols-3 gap-2 border-t border-white/10 bg-[#0E0F12]/95 p-3 backdrop-blur-md md:hidden"
    >
      <Link
        data-testid="sticky-formular-btn"
        to="/formular"
        className="flex flex-col items-center justify-center gap-0.5 rounded-md border border-white/15 py-2 text-[11px] font-semibold text-white"
      >
        <FileText size={18} /> Formular
      </Link>
      <button
        data-testid="sticky-call-btn"
        onClick={onCall}
        className="flex flex-col items-center justify-center gap-0.5 rounded-md border border-white/15 py-2 text-[11px] font-semibold text-white"
      >
        <Phone size={18} /> Anrufen
      </button>
      <button
        data-testid="sticky-whatsapp-btn"
        onClick={onWhatsApp}
        className="flex flex-col items-center justify-center gap-0.5 rounded-md bg-[#25D366] py-2 text-[11px] font-semibold text-[#06231a]"
      >
        <WhatsAppIcon /> WhatsApp
      </button>
    </div>
  );
}
